import { AsyncPipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Button,  DropDownButtonComponent } from "@progress/kendo-angular-buttons";

@Component({
  selector: 'auth-badge',
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
  providers: [
    {
      provide: 'i18n-label',
      useValue: 'BadgeComponent'
    }
  ],
  imports: [Button, DropDownButtonComponent, AsyncPipe]

})
export class BadgeComponent {
  constructor(public auth: AuthService, private router: Router) { }

  loginWithRedirect() {
    this.auth.loginWithRedirect({
      appState: { target: this.router.url }
    });
  }

  logout() {
    this.auth.logout({ logoutParams: { returnTo: window.location.origin } });
  }


}
